import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface OthExpRommsProps {
  onBack: () => void;
}

export default function OthExpRomms({ onBack }: OthExpRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Other Expenses" />;
}


